/**
 * @generated SignedSource<<d5daa7bb7cb46e2be448accbcaa568bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row881BadPattern$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"Row345BadPattern">;
  readonly " $fragmentType": "Row881BadPattern";
};
export type Row881BadPattern$key = {
  readonly " $data"?: Row881BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row881BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDensityFull"
    }
  ],
  "kind": "Fragment",
  "name": "Row881BadPattern",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isDensityFull",
          "variableName": "isDensityFull"
        }
      ],
      "kind": "FragmentSpread",
      "name": "Row345BadPattern"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "1e701cfdc8cd1e7ef1cb28e28b54bb77";

export default node;
